// src/jira/field-configuration/types.ts
var JiraFieldConfigurationAriResourceOwner = "jira", JiraFieldConfigurationAriResourceType = "field-configuration";

export {
  JiraFieldConfigurationAriResourceOwner,
  JiraFieldConfigurationAriResourceType
};
